// Composes the Search Columns modal's rows into one search-bar query string
// in the syntax the backend parser reads: `-`? column ':' (bare | "quoted").
// Kept separate from the modal so the preview the user learns from and the
// query that actually runs are produced by the same code.

const NEEDS_QUOTING = /[\s"\\]/;

// Anything the parser would otherwise chew on — whitespace ends a term, and a
// quote or backslash carries meaning inside one — forces the quoted form.
const formatValue = (value) => {
  if (!NEEDS_QUOTING.test(value)) return value;
  const escaped = value.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  return `"${escaped}"`;
};

export const composeColumnQuery = (rows) =>
  (rows || [])
    .map(({ token, value, negated }) => ({ token, value: (value || '').trim(), negated }))
    .filter(({ token, value }) => token && value)
    .map(({ token, value, negated }) => `${negated ? '-' : ''}${token}:${formatValue(value)}`)
    .join(' ');

export default composeColumnQuery;
